export enum TagConditionOperator {
AND,
OR,
}
